module.exports = __webpack_public_path__ + "img/governo.46332ec4.gif";